import { useQuery } from '@tanstack/react-query';

import { fetchPortalUpgradePreview } from '../services/portalUpgradePreview.api';
import type { PortalBillingPeriod } from '../types/portalPlans';

type UsePortalUpgradePreviewParams = {
  targetPlanCode: string | null;
  billingCycle: PortalBillingPeriod | null;
  enabled: boolean;
};

export function usePortalUpgradePreview({
  targetPlanCode,
  billingCycle,
  enabled,
}: UsePortalUpgradePreviewParams) {
  return useQuery({
    queryKey: ['customer', 'subscription', 'upgrade-preview', targetPlanCode, billingCycle],
    queryFn: () =>
      fetchPortalUpgradePreview({
        targetPlanCode: targetPlanCode!,
        billingCycle: billingCycle!,
      }),
    enabled: enabled && targetPlanCode !== null && billingCycle !== null,
    retry: false,
  });
}
